/**
 * Lazy session-ID accessor for Redux action files.
 *
 * Action files must NOT import `store` at the top level — doing so creates a
 * circular dependency (store/index → reducers → actions → store/index) that
 * Metro resolves non-deterministically, producing "Requiring unknown module
 * '<number>'" errors at runtime.
 *
 * By requiring `store/index` lazily (inside the function body), the module is
 * only accessed after the store has finished initialising, breaking the cycle.
 */

/* eslint-disable @typescript-eslint/no-require-imports */

export const getSessionIds = (): { accountId: string; cognitoId: string } => {
  const { store } = require('../index');
  const state = store.getState();
  return {
    accountId: state.session?.account?.account_id as string,
    cognitoId: state.authentication?.user?.cognito_id as string,
  };
};

/**
 * Session IDs for admin console calls. Identical to getSessionIds for an
 * eleplan-admin on the current account; a tier holder gets their own account,
 * where the tiers live (utilities/adminAccess.ts).
 */
export const getAdminSessionIds = (): { accountId: string; cognitoId: string } => {
  const { store } = require('../index');
  const { resolveAdminViewer } = require('../../utilities/adminAccess');
  const state = store.getState();
  return {
    accountId: resolveAdminViewer(state).accountId as string,
    cognitoId: state.authentication?.user?.cognito_id as string,
  };
};

/** Lazy store accessor for cases that need more than just session IDs. */
export const getStoreState = (): any => {
  const { store } = require('../index');
  return store.getState();
};
